var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.877,
    height: 8.501,
    viewBox: "0 0 14.877 8.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chevron",
    d: "M7.429,7.438.137.7C-.279.319.346-.258.762.127l7.6,7.023A.385.385,0,0,1,8.5,7.5a.4.4,0,0,1-.131.222L.762,14.75c-.417.384-1.041-.193-.625-.577Z",
    transform: "translate(0 8.501) rotate(-90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.30c71c681600d5f47c8e4358af2166e7.svg";
export { ForwardRef as ReactComponent };